<template>
  <div class="create-offer-wrap">
    <div class="main-title">
      <h2>Crear Proveedor</h2>
    </div>
    <div class="section-splitter-wrap">
      <div class="section-splitter-indicators">
        <div class="section-item-indicator section-item-indicator-1 visited" @click="goTab(0)">1</div>
        <div class="section-item-separator section-item-separator-1">
            <div class="separator-filler"></div>
        </div>
        <div class="section-item-indicator section-item-indicator-2" @click="goTab(1)">2</div>
      </div>
      <div class="section-splitter-texts">
        <div class="section-item-text section-item-text-1 visited">
          Informacion del Negocio
        </div>
        <div class="section-item-text section-item-text-2">
          Contactos
        </div>
      </div>
    </div>
    <div class="form-section-scroller">
      <!--        "no" means for "new offer" -->
       <div class="no-section-wrap no-section-wrap-1">
         <div class="row">
           <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Nombre Legal
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Nombre Legal" v-model="form.legal_name">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Nombre para Mostrar 
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Nombre para Mostrar" v-model="form.display_name">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-lg-2">
            <div class="no-form-group">
              <div class="no-form-label">
                  Comisión
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Comisión" v-model="form.retention">
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="no-form-group">
              <div class="no-form-label">
                  Cuenta Bancaria
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Cuenta Bancaria" v-model="form.account">
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="no-form-group">
              <div class="no-form-label">
                  Banco
              </div>
              <div class="no-form-input">
                <select v-model="form.bank_id">
                    <option value="0">Seleccione un elemento</option>
                    <option v-for="bank in banks" v-bind:value="bank.id">
                    {{ bank.name }}
                    </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Aplica Impuestos
              </div>
              <div class="no-form-input">
                   <select v-model="form.apply_tax">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                   </select>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Límite de Consumo Diario
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Límite de Consumo Diario" v-model="form.day_limit">
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Aplica Llamadas Externas
              </div>
              <div class="no-form-input">
                   <select v-model="form.apikey">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                   </select>
              </div>
            </div>
          </div>
        </div>
            <div class="no-form-group">
                <div class="no-form-label">
                    Dirección
                </div>
                <div class="no-form-input">
                    <textarea placeholder="Dirección aquí" v-model="form.address"></textarea>
                </div>
            </div>
          <div class="new-offer-buttons">
            <button class="new-offer-btn new-offer-btn-1" id="newOfferGrayBtn" @click="cancel()">Cancelar</button>
            <button class="new-offer-btn new-offer-btn-success new-offer-btn-2" id="newOfferGreenBtn" @click="goTab(1)">Siguiente</button>
          </div>
       </div>
        <div class="no-section-wrap no-section-wrap-2">
         <div class="row">
           <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Teléfono Principal
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Teléfono" v-model="form.phone">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Celular 
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Celular" v-model="form.cellphone">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Email
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Email" v-model="form.email">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="no-form-group">
              <div class="no-form-label">
                  Web Site
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Web Site" v-model="form.website">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Representante
              </div>
              <div class="no-form-input">
                  <input type="text" placeholder="Representante" v-model="form.representative.name">
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Teléfono
              </div>
              <div class="no-form-input">
                   <input type="text" placeholder="Representante" v-model="form.representative.phone">
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="no-form-group">
              <div class="no-form-label">
                  Email
              </div>
              <div class="no-form-input">
                   <input type="text" placeholder="Representante" v-model="form.representative.email">
              </div>
            </div>
          </div>
        </div>
          <div class="new-offer-buttons">
            <button class="new-offer-btn new-offer-btn-1" id="newOfferGrayBtn" @click="goTab(0)">Volver atrás</button>
            <button class="new-offer-btn new-offer-btn-success new-offer-btn-2" id="newOfferGreenBtn" @click="created()">Crear</button>
          </div>
       </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "create-provider",
  data: () => {
    return {
      loading:false,
      form:{
        legal_name:null,
        display_name:null,
        retention:null,
        account:null,
        bank_id:null,
        apply_tax:null,
        day_limit:null,
        apikey:null,
        address:null,
        phone:null,
        cellphone:null,
        email:null,
        website:null,
        representative:{
            name:null,
            phone:null,
            email:null
        }
      },
      response:{
          shops:{
              nickname:null,
              password:null,
          }
      },
      banks:[{
            id:1,
            name:"BANCO POPULAR DOMINICANO",
        },{
            id:2,
            name:"BANCO BHD LEON",
        },{
            id:3,
            name:"BANCO DE RESERVAS",
        },{
            id:4,
            name:"BANCO SCOTIABANK",
        },{
            id:5,
            name:"CITIBANK",
        },{
            id:6,
            name:"BANCO DEL PROGRESO",
        },{
            id:7,
            name:"BANCO DE DESARROLLO ADEMI",
        },{
            id:8,
            name:"BANCO SANTA CRUZ",
        },{
            id:9,
            name:"BANCO CARIBE",
        },{
            id:10,
            name:"BANCO BDI",
        },{
            id:11,
            name:"BANCO VIMENCA",
        },{
            id:12,
            name:"BANCO LOPEZ DE HARO",
        },{
            id:13,
            name:"BANCAMERICA",
        },{
            id:14,
            name:"BANCO BANESCO",
        },{
            id:15,
            name:"BANCO PROMERICA",
        },{
            id:16,
            name:"ASOCIACION POPULAR DE AHORROS Y PRESTAMOS",
        },{
            id:17,
            name:"ASOCIACION CIBAO",
        },{
            id:18,
            name:"ASOCIACION LA NACIONAL",
        }
      ]
    }
  },
  async created() {
      
  },
  methods: {
    goTab: function (tab) {
      let scrollerItemsBase = document.querySelector('.no-section-wrap.no-section-wrap-1');
      let indicators = document.querySelectorAll('.section-item-indicator');

      scrollerItemsBase.style.marginLeft = `calc(-100% * ${tab})`;

      indicators.forEach((indicator, i) => {
        if (tab > i) indicator.classList.add('passed');

        if (tab == i) {
          indicator.classList.add('visited');
          indicator.classList.remove('passed');
        }

        if (tab < i) {
          indicator.classList.remove('visited');
          indicator.classList.remove('passed');
        }
      });
    },
    created(){
      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + '/providers',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: this.form,
      }).then(function(response) {
        sweetAlert("Success", "Registro creado exitosamente !", "success");
        window.location = "/#!/administrator/offers";
      }, response => {
        sweetAlert("Oops...", "¡Ha ocurrido un error! " + response.data.status.message, "error");
      });
    },
    cancel(){
      window.location = "/#!/administrator/offers";
    }
  }
}
</script>

<style scoped>
    .create-offer-wrap {
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
    }

    .create-offer-wrap * {
      -webkit-transition: all .3s;
      transition: all .3s;
    }

    .create-offer-wrap .main-title > h2,
    .no-product-title h2 {
      font-weight: 800;
    }

    .section-splitter-indicators {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .section-item-indicator {
      display: inherit;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      background-color: #FFF;
      color: #EBEBEB;
      justify-content: center;
      align-items: center;
      font-weight: 800;
      border: 1px solid #EBEBEB;
      cursor: pointer;
    }

    .section-item-indicator.visited {
      background-color: #213F99;
    }

    .section-item-indicator.passed + .section-item-separator .separator-filler {
      width: 100%
    }

    .section-item-separator {
      height: 2px;
      width: 120px;
      background-color: #EBEBEB;
    }

    .section-item-separator .separator-filler {
      background-color: #213F99;
      width: 0%;
      height: 100%;
    }

    .section-splitter-texts {
      display: flex;
      font-size: 12px;
      margin-top: 5px;
      justify-content: center;
    }

    .section-item-text {
      width: 162px;
      text-align: center;
      color: #888;
    }

    .section-item-text.visited {
      color: #213F99;
    }

    .form-section-scroller {
      margin-top: 40px;
      margin-bottom: 25px;
      display: flex;
      overflow-x: hidden;
    }

    .form-section-scroller > div {
      min-width: 100%;
      max-width: 100%;
      height: 100%;
      display: flex;
      flex-flow: column;
    }

    .no-form-label {
      font-size: 12px;
      margin-bottom: 7px;
      text-align: left;
    }

    .no-form-input {
      display: flex;
      margin-bottom: 20px;
    }

    .no-form-input input,
    .no-form-input select,
    .no-form-input textarea,
    .no-form-input label {
      border: 1px solid #EAEAEA;
      background-color: #fff;
      padding: 14px 20px;
      width: 100%;
      font-size: 12px;
      border-radius: 0;
    }

    .no-form-input input::-webkit-input-placeholder,
    .no-form-input textarea::-webkit-input-placeholder {
      color: #888;
    }

    .no-form-input select {
      color: #888;
    }

    .no-form-input select > option:not(:first-of-type) {
      color: #000;
    }

    .no-form-input textarea {
      min-height: 100px;
    }

    .file-upload {
      margin-bottom: 50px;
    }

    .file-upload input[type="file"] {
      display: none;
    }

    .file-upload label {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 0;
      color: #888;
      flex-flow: column;
    }

    .file-upload label i {
      font-size: 40px;
      opacity: .5;
      margin-bottom: 5px;
    }

    .file-upload .no-form-input {
      margin-bottom: 8px;
    }

    .file-upload .no-form-label {
      color: #888;
      text-align: center;
    }

    .new-offer-buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      flex: 1;
      align-items: flex-end;
    }

    .new-offer-buttons button {
      border-radius: 5px;
      border: 0;
      padding: 15px;
      width: 47%;
      min-width: 100px;
      background-color: #6C6C6C;
      color: #fff;
      text-transform: uppercase;
      font-weight: 800;
      cursor: pointer;
    }

    .new-offer-buttons button:focus {
      outline: none;
    }

    .new-offer-btn-success {
      background-color: #38B449 !important;
    }

    .no-product-wrap {
      max-width: 500px;
      margin: 0 auto;
    }

    .no-product-wrap > h3 {
      font-weight: lighter;
      color: #ccc;
    }

    /* Temporal row style emulation */

    /* .row {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
    }

    .row .col-lg-6 {
      width: 47%;
    } */



a{
  text-decoration: none;
}

.main-wrap {
    background: #000;
        text-align: center;
}
.main-wrap h1 {
        color: #fff;
            margin-top: 50px;
    margin-bottom: 100px;
}
.col-md-3 {
	display: block;
	float:left;
	margin: 1% 0 1% 1.6%;
	  background-color: #eee;
  padding: 50px 0;
}

.col:first-of-type {
  margin-left: 0;
}


/* ALL LOADERS */

.loader{
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

/* LOADER 1 */

#loader-1:before, #loader-1:after{
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 10px solid transparent;
  border-top-color: #38b449;
}

#loader-1:before{
  z-index: 100;
  animation: spin 1s infinite;
}

#loader-1:after{
  border: 10px solid #ccc;
}

@keyframes spin{
  0%{
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100%{
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* LOADER 2 */

#loader-2 span{
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #38b449;
  margin: 35px 5px;
}

#loader-2 span:nth-child(1){
  animation: bounce 1s ease-in-out infinite;
}

#loader-2 span:nth-child(2){
  animation: bounce 1s ease-in-out 0.33s infinite;
}

#loader-2 span:nth-child(3){
  animation: bounce 1s ease-in-out 0.66s infinite;
}

@keyframes bounce{
  0%, 75%, 100%{
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }

  25%{
    -webkit-transform: translateY(-20px);
    -ms-transform: translateY(-20px);
    -o-transform: translateY(-20px);
    transform: translateY(-20px);
  }
}

/* LOADER 3 */

#loader-3:before, #loader-3:after{
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: calc(50% - 10px);
  background-color: #38b449;
  animation: squaremove 1s ease-in-out infinite;
}

#loader-3:after{
  bottom: 0;
  animation-delay: 0.5s;
}

@keyframes squaremove{
  0%, 100%{
    -webkit-transform: translate(0,0) rotate(0);
    -ms-transform: translate(0,0) rotate(0);
    -o-transform: translate(0,0) rotate(0);
    transform: translate(0,0) rotate(0);
  }

  25%{
    -webkit-transform: translate(40px,40px) rotate(45deg);
    -ms-transform: translate(40px,40px) rotate(45deg);
    -o-transform: translate(40px,40px) rotate(45deg);
    transform: translate(40px,40px) rotate(45deg);
  }

  50%{
    -webkit-transform: translate(0px,80px) rotate(0deg);
    -ms-transform: translate(0px,80px) rotate(0deg);
    -o-transform: translate(0px,80px) rotate(0deg);
    transform: translate(0px,80px) rotate(0deg);
  }

  75%{
    -webkit-transform: translate(-40px,40px) rotate(45deg);
    -ms-transform: translate(-40px,40px) rotate(45deg);
    -o-transform: translate(-40px,40px) rotate(45deg);
    transform: translate(-40px,40px) rotate(45deg);
  }
}

/* LOADER 4 */

#loader-4 span{
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #38b449;
  margin: 35px 5px;
  opacity: 0;
}

#loader-4 span:nth-child(1){
  animation: opacitychange 1s ease-in-out infinite;
}

#loader-4 span:nth-child(2){
  animation: opacitychange 1s ease-in-out 0.33s infinite;
}

#loader-4 span:nth-child(3){
  animation: opacitychange 1s ease-in-out 0.66s infinite;
}

@keyframes opacitychange{
  0%, 100%{
    opacity: 0;
  }

  60%{
    opacity: 1;
  }
}

/* LOADER 5 */

#loader-5 span{
  display: block;
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  width: 20px;
  height: 20px;
  background-color: #38b449;
}

#loader-5 span:nth-child(2){
  animation: moveanimation1 1s ease-in-out infinite;
}

#loader-5 span:nth-child(3){
  animation: moveanimation2 1s ease-in-out infinite;
}

#loader-5 span:nth-child(4){
  animation: moveanimation3 1s ease-in-out infinite;
}

@keyframes moveanimation1{
  0%, 100%{
    -webkit-transform: translateX(0px);
    -ms-transform: translateX(0px);
    -o-transform: translateX(0px);
    transform: translateX(0px);
  }

  75%{
    -webkit-transform: translateX(30px);
    -ms-transform: translateX(30px);
    -o-transform: translateX(30px);
    transform: translateX(30px);
  }
}

@keyframes moveanimation2{
  0%, 100%{
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  75%{
    -webkit-transform: translateY(30px);
    -ms-transform: translateY(30px);
    -o-transform: translateY(30px);
    transform: translateY(30px);
  }
}

@keyframes moveanimation3{
  0%, 100%{
    -webkit-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    -o-transform: translate(0px, 0px);
    transform: translate(0px, 0px);
  }

  75%{
    -webkit-transform: translate(30px, 30px);
    -ms-transform: translate(30px, 30px);
    -o-transform: translate(30px, 30px);
    transform: translate(30px, 30px);
  }
}

/* LOADER 6 */

#loader-6{
  top: 40px;
  left: -2.5px;
}

#loader-6 span{
  display: inline-block;
  width: 5px;
  height: 20px;
  background-color: #38b449;
}

#loader-6 span:nth-child(1){
  animation: grow 1s ease-in-out infinite;
}

#loader-6 span:nth-child(2){
  animation: grow 1s ease-in-out 0.15s infinite;
}

#loader-6 span:nth-child(3){
  animation: grow 1s ease-in-out 0.30s infinite;
}

#loader-6 span:nth-child(4){
  animation: grow 1s ease-in-out 0.45s infinite;
}

@keyframes grow{
  0%, 100%{
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    -o-transform: scaleY(1);
    transform: scaleY(1);
  }

  50%{
    -webkit-transform: scaleY(1.8);
    -ms-transform: scaleY(1.8);
    -o-transform: scaleY(1.8);
    transform: scaleY(1.8);
  }
}

/* LOADER 7 */

#loader-7{
  -webkit-perspective: 120px;
  -moz-perspective: 120px;
  -ms-perspective: 120px;
  perspective: 120px;
}

#loader-7:before{
  content: "";
  position: absolute;
  left: 25px;
  top: 25px;
  width: 50px;
  height: 50px;
  background-color: #38b449;
  animation: flip 1s infinite;
}

@keyframes flip {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(180deg)  rotateX(180deg);
  }
}

/* LOADER 8 */

#loader-8:before{
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  top: calc(50% - 10px);
  left: 0px;
  background-color: #38b449;
  animation: rotatemove 1s infinite;
}

@keyframes rotatemove{
  0%{
    -webkit-transform: scale(1) translateX(0px);
    -ms-transform: scale(1) translateX(0px);
    -o-transform: scale(1) translateX(0px);
    transform: scale(1) translateX(0px);
  }

  100%{
    -webkit-transform: scale(2) translateX(45px);
    -ms-transform: scale(2) translateX(45px);
    -o-transform: scale(2) translateX(45px);
    transform: scale(2) translateX(45px);
  }
}

</style>



// WEBPACK FOOTER //
// create.vue?992a989a